<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-folder-open mr-4"></i>Files</span>
        </h1>
        <main class="overflow-x-hidden overflow-y-scroll flex-1 bg-white rounded-xl">
            <fs v-if="filesystemId" :filesystem-id="filesystemId"></fs>
        </main>
    </div>
</template>

<script>
import {PackageNew} from "@models";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            filesystemId: null
        }
    },
    computed: {},
    methods: {
    },
    async mounted() {
        PackageNew.findEstimation(this.dashboardData.package.referenceNumber).then(async (result) => {
            this.filesystemId = result.filesystemId
        })
    }
}

</script>